import queryString from "query-string";
import catalogContexts from "@utils/constants/catalogContexts";

const mainIndex = process.env.NEXT_PUBLIC_ALGOLIA_MAIN_INDEX_V2;

export default function computeQueryPathArray(routeState, listingPage, personalised, context) {
  const queryPathArray = [];
  const listingPageQueryKeys = listingPage
    ? Object.keys(queryString.parse(listingPage.search_query, { arrayFormat: "bracket" }))
    : [];

  // query for search
  if (routeState[mainIndex]?.query && !listingPageQueryKeys.includes("search")) {
    queryPathArray.push(queryString.stringify({ search: routeState[mainIndex].query }));
  }

  // query for page
  const routeStatePage = routeState[mainIndex]?.page;
  if (routeStatePage > 1 && !listingPageQueryKeys.includes("page")) {
    queryPathArray.push(queryString.stringify({ page: routeStatePage }));
  }

  // query for sortBy
  if (
    routeState[mainIndex]?.sortBy &&
    !listingPageQueryKeys.includes("order_by") &&
    ![catalogContexts.wishlist, catalogContexts.userlist].includes(context)
  ) {
    const indexSuffix = routeState[mainIndex].sortBy.split("-").pop();
    if (!["swap", "sales"].includes(indexSuffix))
      queryPathArray.push(queryString.stringify({ order_by: indexSuffix }));
  }

  // queries for refinementList
  const refinementList = routeState[mainIndex]?.refinementList || {};

  const findAppliedSizesKey = () => {
    if (refinementList.available_sizes?.length > 0) return "available_sizes";

    return "sizes";
  };
  const appliedSizesKey = findAppliedSizesKey();

  if (catalogContexts.userlist === context) {
    if (refinementList.in_stock?.length == 1) {
      queryPathArray.push(queryString.stringify({ availabilities: "in_stock" }));
    }
  } else if (
    refinementList.in_stock?.length > 1 &&
    !listingPageQueryKeys.includes("availabilities")
  ) {
    queryPathArray.push(queryString.stringify({ availabilities: "all" }));
  }

  if (refinementList.segment?.length > 0 && !listingPageQueryKeys.includes("kinds")) {
    queryPathArray.push(
      queryString.stringify({ kinds: refinementList.segment }, { arrayFormat: "bracket" }),
    );
  }

  if (
    refinementList.category?.length > 0 &&
    !listingPageQueryKeys.includes("category") &&
    !listingPageQueryKeys.includes("clothes") &&
    !listingPageQueryKeys.includes("accessories")
  ) {
    queryPathArray.push(
      queryString.stringify({ category: refinementList.category }, { arrayFormat: "bracket" }),
    );
  }

  if (refinementList[appliedSizesKey]?.length > 0 && !listingPageQueryKeys.includes("sizes")) {
    const sizesWithoutTU = refinementList[appliedSizesKey].filter((size) => size !== "TU");
    queryPathArray.push(
      queryString.stringify({ sizes: sizesWithoutTU }, { arrayFormat: "bracket" }),
    );
  }

  if (refinementList.colors?.length > 0 && !listingPageQueryKeys.includes("colors")) {
    queryPathArray.push(
      queryString.stringify({ colors: refinementList.colors }, { arrayFormat: "bracket" }),
    );
  }

  if (refinementList.season?.length > 0 && !listingPageQueryKeys.includes("seasons")) {
    queryPathArray.push(
      queryString.stringify({ seasons: refinementList.season }, { arrayFormat: "bracket" }),
    );
  }

  if (refinementList.sleeves?.length > 0 && !listingPageQueryKeys.includes("sleeves")) {
    queryPathArray.push(
      queryString.stringify({ sleeves: refinementList.sleeves }, { arrayFormat: "bracket" }),
    );
  }

  if (refinementList.legs?.length > 0 && !listingPageQueryKeys.includes("legs")) {
    queryPathArray.push(
      queryString.stringify({ legs: refinementList.legs }, { arrayFormat: "bracket" }),
    );
  }

  if (refinementList["brand.name"]?.length > 0 && !listingPageQueryKeys.includes("brands")) {
    queryPathArray.push(
      queryString.stringify({ brands: refinementList["brand.name"] }, { arrayFormat: "bracket" }),
    );
  }

  // query for personalised
  if (personalised && personalised !== "all" && !listingPageQueryKeys.includes("personalised")) {
    queryPathArray.push(
      queryString.stringify({ personalised: [personalised] }, { arrayFormat: "bracket" }),
    );
  }

  return queryPathArray;
}
